import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

const DEVICE_KEY = "rased_device_id";
const getDeviceId = () => {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };

  const register = async (name, email, password, plan = "trial", phone = "") => {
    const { data } = await api.post("/auth/register",
      { name, email, password, phone, plan, device_id: getDeviceId() });
    setUser(data);
    return data;
  };

  const verifyEmail = async (code) => {
    const { data } = await api.post("/auth/verify-email", { code });
    setUser(data);
    return data;
  };

  const resendVerification = async () => {
    await api.post("/auth/resend-verification");
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, register, verifyEmail, resendVerification, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
